// ABOUTME: Star-constellation icon, ported from the Ohana Dashboard mockup — used on the
// ABOUTME: "Stars logged" stat tile and, under the nalu-v1 theme, the Star tally button
// ABOUTME: Inline SVG (no standalone asset file exists for this icon in the design handoff)

import React from 'react';
import { useTheme } from '@mui/material/styles';

interface StarConstellationIconProps {
  size?: number;
  /** True when embedded in an already-labeled control (e.g. a button with its own aria-label) — omits the SVG's own role/aria-label to avoid a redundant nested accessible name. */
  decorative?: boolean;
}

export const StarConstellationIcon: React.FC<StarConstellationIconProps> = ({ size = 54, decorative = false }) => {
  const theme = useTheme();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 54 54"
      {...(decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': 'Star' })}
    >
      <rect width="54" height="54" rx="14" fill={theme.palette.background.paper} />
      <path d="M17 21 L37 14 M37 14 L32 39 M17 21 L32 39" stroke={theme.palette.primary.main} strokeWidth="1.2" opacity="0.35" fill="none" />
      <polygon points="17,12 19.7,18.3 26,21 19.7,23.7 17,30 14.3,23.7 8,21 14.3,18.3" fill={theme.palette.primary.main} />
      <polygon points="37,9.5 38.35,12.65 41.5,14 38.35,15.35 37,18.5 35.65,15.35 32.5,14 35.65,12.65" fill={theme.palette.primary.main} />
      <polygon points="32,33.5 33.65,37.35 37.5,39 33.65,40.65 32,44.5 30.35,40.65 26.5,39 30.35,37.35" fill={theme.palette.primary.main} />
      <circle cx="44" cy="31" r="1.4" fill={theme.palette.primary.main} opacity="0.6" />
      <circle cx="12" cy="38" r="1.4" fill={theme.palette.primary.main} opacity="0.6" />
      <circle cx="24" cy="9" r="1.2" fill={theme.palette.primary.main} opacity="0.6" />
    </svg>
  );
};
